import * as R from 'ramda';
import mixpanel from 'mixpanel-browser';

import {
  coreSelectors,
} from '@gymcloud/core';

const events = {
  signup_submit: {
    name: 'Signup Submit',
    model: {
    },
    extra: (profile, attrs) => ({
      'User Email': attrs.email,
      'User Name': `${attrs.first_name} ${attrs.last_name}`,
    }),
  },

  pro_signup: {
    name: 'Pro Account Created',
    model: {},
    extra: (profile, attrs) => ({
      'User ID': attrs.id,
      'User Email': attrs.email,
      'User Name': `${attrs.first_name} ${attrs.last_name}`,
    }),
  },

  client_accepted_invitation: {
    name: 'Client Accepted Invitation',
    model: {},
    extra: (profile, attrs) => ({
      'User ID': attrs.id,
      'User Email': attrs.email,
      'User Name': `${attrs.first_name} ${attrs.last_name}`,
    }),
  },

  confirm_email: {
    name: 'Email Confirmed',
    model: {
      eventCategory: 'confirm-email',
      eventAction: 'confirmed',
      eventLabel: 'new-user',
    },
  },

  pro_login: {
    name: 'Pro Login',
    model: {
      'User ID': 'id',
      'User Email': 'email',
      'User Name': 'user_profile.full_name',
    },
    extra: () => ({
      'Login Time': new Date(),
    }),
  },

  client_login: {
    name: 'Client Login',
    model: {
      'User ID': 'id',
      'User Email': 'email',
      'User Name': 'user_profile.full_name',
    },
    extra: () => ({
      'Login Time': new Date(),
    }),
  },

  pro_logout: {
    name: 'Pro Logout',
    model: {
      'User ID': 'id',
      'User Email': 'email',
      'User Name': 'user_profile.full_name',
    },
    extra: () => ({
      'Logout Time': new Date(),
    }),
  },

  client_logout: {
    name: 'Client Logout',
    model: {
      'User ID': 'id',
      'User Email': 'email',
      'User Name': 'user_profile.full_name',
    },
    extra: () => ({
      'Logout Time': new Date(),
    }),
  },

  client_added: {
    name: 'Client Added',
    model: {
      'User ID': 'id',
      'User Name': 'user_profile.full_name',
    },
    extra: (profile, attrs) => ({
      'Client Name': attrs.full_name,
    }),
  },

  client_invited: {
    name: 'Client Invited',
    model: {
      'User ID': 'id',
      'User Name': 'user_profile.full_name',
    },
    extra: (profile, attrs) => ({
      'Client Name': attrs.full_name,
      'Client Email': attrs.email,
    }),
  },

  client_group_created: {
    name: 'Client Group Created',
    model: {
      'User ID': 'id',
      'User Name': 'user_profile.full_name',
    },
    extra: (profile, attrs) => ({
      'Client Group ID': attrs.id,
      'Client Group Name': attrs.name,
    }),
  },

  client_group_member_added: {
    name: 'Client Group Member Added',
    model: {
      'User ID': 'id',
      'User Name': 'user_profile.full_name',
    },
    extra: (profile, attrs) => ({
      'Group ID': attrs.groupId,
      'Group Name': attrs.groupName,
      'Client ID': attrs.clientId,
      'Client Name': attrs.clientName,
    }),
  },

  client_group_member_removed: {
    name: 'Client Group Member Removed',
    model: {
      'User ID': 'id',
      'User Name': 'user_profile.full_name',
    },
    extra: (profile, attrs) => ({
      'Group ID': attrs.groupId,
      'Group Name': attrs.groupName,
      'Client ID': attrs.clientId,
      'Client Name': attrs.clientName,
    }),
  },

  library_item_created: {
    name: 'Library Item Created',
    model: {
      'User ID': 'id',
      'User Name': 'user_profile.full_name',
    },
    extra: (profile, attrs) => ({
      'Item ID': attrs.id,
      'Item Name': attrs.name,
      'Item Type': attrs.type,
    }),
  },

  library_item_assigned: {
    name: 'Library Item Assigned',
    model: {
      'User ID': 'id',
      'User Name': 'user_profile.full_name',
    },
    extra: (profile, attrs) => ({
      'Item ID': attrs.id,
      'Item Name': attrs.name,
      'Item Type': attrs.type,
      'Person ID': attrs.personId,
    }),
  },

  library_item_unassigned: {
    name: 'Library Item Unassigned',
    model: {
      'User ID': 'id',
      'User Name': 'user_profile.full_name',
    },
    extra: (profile, attrs) => ({
      'Item ID': attrs.id,
      'Item Name': attrs.name,
      'Item Type': attrs.type,
      'Person ID': attrs.personId,
    }),
  },

  pro_started_workout: {
    name: 'Pro Started Workout',
    model: {
      'User ID': 'id',
      'User Name': 'user_profile.full_name',
    },
    extra: (profile, attrs) => ({
      'Person ID': attrs.person_id,
      'Person Name': attrs.person_name,
      'Workout ID': attrs.personal_workout_id,
      'Workout Name': attrs.workout_name,
      'Workout Begins At': attrs.begins_at,
      'Workout Ends At': attrs.ends_at,
    }),
  },

  client_started_workout: {
    name: 'Client Started Workout',
    model: {
      'User ID': 'id',
      'User Name': 'user_profile.full_name',
    },
    extra: (profile, attrs) => ({
      'Person ID': attrs.person_id,
      'Person Name': attrs.person_name,
      'Workout ID': attrs.personal_workout_id,
      'Workout Name': attrs.workout_name,
      'Workout Begins At': attrs.begins_at,
      'Workout Ends At': attrs.ends_at,
    }),
  },

  pro_scheduled_workout: {
    name: 'Pro Scheduled Workout',
    model: {
      'User ID': 'id',
      'User Name': 'user_profile.full_name',
    },
    extra: (profile, attrs) => ({
      'Person ID': attrs.person_id,
      'Person Name': attrs.person_name,
      'Workout ID': attrs.personal_workout_id,
      'Workout Name': attrs.workout_name,
      'Workout Begins At': attrs.begins_at,
      'Workout Ends At': attrs.ends_at,
    }),
  },

  client_scheduled_workout: {
    name: 'Client Scheduled Workout',
    model: {
      'User ID': 'id',
      'User Name': 'user_profile.full_name',
    },
    extra: (_: any, attrs: any) => ({
      'Person ID': attrs.person_id,
      'Person Name': attrs.person_name,
      'Workout ID': attrs.personal_workout_id,
      'Workout Name': attrs.workout_name,
      'Workout Begins At': attrs.begins_at,
      'Workout Ends At': attrs.ends_at,
    }),
  },

  pro_completed_workout: {
    name: 'Pro Completed Workout',
    model: {
      'User ID': 'id',
      'User Name': 'user_profile.full_name',
    },
    extra: (_: any, attrs: any) => ({
      'Person ID': attrs.person_id,
      'Person Name': attrs.person_name,
      'Workout ID': attrs.personal_workout_id,
      'Workout Name': attrs.workout_name,
      'Workout Begins At': attrs.begins_at,
      'Workout Ends At': attrs.ends_at,
    }),
  },

  client_completed_workout: {
    name: 'Client Completed Workout',
    model: {
      'User ID': 'id',
      'User Name': 'user_profile.full_name',
    },
    extra: (_: any, attrs: any) => ({
      'Person ID': attrs.person_id,
      'Person Name': attrs.person_name,
      'Workout ID': attrs.personal_workout_id,
      'Workout Name': attrs.workout_name,
      'Workout Begins At': attrs.begins_at,
      'Workout Ends At': attrs.ends_at,
    }),
  },
};

const analyticMiddleware = (store) => (next) => (action) => {
  const {
    attrs,
    eventKey,
  } = action;

  if (action.type !== 'GC_ANALYTICS' || !events[eventKey]) {
    return next(action);
  }

  try {
    const state = store.getState();
    const profile = coreSelectors.getProfile(state);
    const { name, model, extra } = events[eventKey];

    const props = {
      ...(model
        ? Object
          .keys(model)
          .reduce((acc, key) => ({
            ...acc,
            [key]: R.path(model[key].split('.'), profile),
          }), {})
        : {}
      ),
      ...(extra
        ? extra.call(undefined, profile, attrs)
        : {}
      ),
    };

    mixpanel.track(name, props);
  } catch (error) {
    console.log('error', error);
  }
  return next(action);
};

export default analyticMiddleware;
